enum CustomEventLogMode {
    Standalone = 0,
    Begin = 1,
    End = 2
}

export { CustomEventLogMode };
